import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Schedule, ChevronRight, AttachMoney } from '@mui/icons-material';
import ListTitleBox from '../../../app/components/list/ListTitleBox';
import StyledTableRow from '../../../app/components/StyledTableRow';

export default function RestaurantSettings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { restaurantId } = useParams<{ restaurantId: string }>();

  return (
    <>
      <ListTitleBox title={t('restaurant.settings.title')} />
      <TableContainer
        component={Paper}
        sx={{
          width: '100%',
          mb: 1,
          px: 0,
          '& tr:last-child td': { borderBottom: 'none' },
        }}
      >
        <Table>
          <TableBody>
            <StyledTableRow
              onClick={() => navigate('opening-hours')}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Schedule color="primary" />
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {t('restaurant.settings.links.opening-hours')}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell
                align="right"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <ChevronRight sx={{ color: 'text.secondary' }} />
              </TableCell>
            </StyledTableRow>
            <StyledTableRow
              onClick={() =>
                navigate(`/manager/restaurants/${restaurantId}/taxes`)
              }
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AttachMoney color="primary" />
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {t('restaurant.settings.links.tax-rates')}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell
                align="right"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <ChevronRight sx={{ color: 'text.secondary' }} />
              </TableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
